import { createSelector } from 'reselect';
import { Notification } from 'types/notifications';
import { filter } from 'ramda';
import { RecruiterEvent, EmployerEvent } from 'types/pusher';

export const getNotifications = createSelector(
  (state: any) => state.notifications,
  filter((n: Notification) => n.type === 'received') as (n: Notification[]) => Notification[]
);

export const getUnreadNotifications = createSelector(
  getNotifications,
  filter((n: Notification) => n.status === 'new' && n.type === 'received') as (
    n: Notification[]
  ) => Notification[]
);

export const getUnreadNotificationsCount = createSelector(
  getUnreadNotifications,
  (notifications: Notification[]) => notifications.length
);

export const getNotificationLink = (notification: any) => {
  switch (notification.event) {
    case RecruiterEvent.CANDIDATE_MOVED:
      return `/job-board/${notification.jobId}`;
    case RecruiterEvent.JOB_DELETED:
      return '/job-posts';
    case RecruiterEvent.OFFER_MADE:
      return `/candidate-details/${notification.candidateId}`;
    case RecruiterEvent.CANDIDATE_NOTE:
      return `/candidate-details/${notification.refId}`;
    case RecruiterEvent.CANDIDATED_SUBMITTED:
      return `/candidate-details/${notification.candidateId}`;
    case EmployerEvent.CANDIDATE_ASSIGNED:
      return `/candidate-details/${notification.candidateId}`;
    case EmployerEvent.CANDIDATE_NOTE:
      return `/candidate-details/${notification.refId}`;
    case EmployerEvent.OFFER_ACCEPTED:
      return `/candidate-details/${notification.candidateId}`;
    case EmployerEvent.INVOICE_SENT:
      return `/candidate-details/${notification.candidateId}`;
    default:
      return null;
  }
};
